import { z, ZodType } from 'zod';
import { zObject } from '../../util/zod';
import { jHref, jHrefSchema } from '../utils';
import { widgetBaseSchema, WidgetsName, WidgetType } from './common';
import { jFileLittle, jFileLittleSchema } from '../file';

export type WidgetCheckListContentArr = {
    title: string;
    value?: boolean;
    links?: jHref[];
    id?: number;
    file?: jFileLittle;
    user?: {
        id: number | string;
        type: string;
        mainType: string;
    };
};
export const widgetCheckListContentArrSchema = zObject<WidgetCheckListContentArr>({
    title: z.string(),
    value: z.boolean().optional(),
    links: jHrefSchema.array().optional(),
    id: z.number().optional(),
    file: jFileLittleSchema.optional(),
    user: z
        .object({
            id: z.number().or(z.string()),
            type: z.literal('user'),
            mainType: z.literal('user'),
        })
        .optional(),
});

export const widgetCheckListContentSchema = z.object({
    arr: widgetCheckListContentArrSchema.array().optional(),
    css: z.record(z.string(), z.string()).optional(),
    widgets: widgetBaseSchema.array().optional(),
    edit: z.boolean().optional(),
});

export type WidgetCheckListContent = z.infer<typeof widgetCheckListContentSchema>;

export type WidgetCheckListType = {
    name: WidgetsName.CheckList;
    uniqid: string;
    content: WidgetCheckListContent;
};
export const widgetCheckListTypeSchema: ZodType<WidgetType<WidgetCheckListContent>> = zObject<WidgetCheckListType>({
    name: z.literal(WidgetsName.CheckList),
    uniqid: z.string(),
    content: widgetCheckListContentSchema,
}) satisfies ZodType<WidgetType<WidgetCheckListContent>>;
